import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { syncPublicStats } from '../../Actions/FeaturedActions';
import { syncCurrentUser } from '../../Actions/UserActions';
import { markBrandOnboardingPanelViewed } from '../../Actions/OnboardingActions';

import { getBrand } from '../../Helpers/user_helpers';
import { intitializeIntercom } from '../../Helpers/chat_helpers';
import { hasCompletedBrandOnboarding } from '../../Helpers/user_helpers';

const BrandOnboardingData = props => {
  const { user, featured } = props;
  const history = useHistory();

  useEffect(() => {
    if (!_.isEmpty(featured?.publicStats)) return;
    props.syncPublicStats();
  }, [featured?.publicStats]);

  useEffect(() => {
    if (!user) return;
    else {
      props.syncCurrentUser();
      intitializeIntercom(user);
    }

    if (hasCompletedBrandOnboarding(user)) {
      window.ALERT.info('Your brand onboarding is already complete. Redirecting you to your dashboard.');
      history.push('/links');
    }
  }, [user.profile?.id]);

  useEffect(() => {
    props.markBrandOnboardingPanelViewed(props.activePanelName);
  }, [props.activePanelName]);

  return null;
};

BrandOnboardingData.propTypes = {
  user: PropTypes.object,
  featured: PropTypes.object,
  syncCurrentUser: PropTypes.func.isRequired,
  syncPublicStats: PropTypes.func.isRequired,

  activePanelName: PropTypes.string
};

const mapStateToProps = state => ({
  user: state.user,
  featured: state.featured
});

export default connect(mapStateToProps, {
  syncCurrentUser,
  syncPublicStats,
  markBrandOnboardingPanelViewed
})(BrandOnboardingData);
